import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'

Radio.Group = RadioGroup

export default Radio
